export default __webpack_public_path__ + "static/media/error.a02fb7e7.svg";